import { fetchGuestRsvp } from '@bridebook/web/app-basic/lib/rsvp/api';
import { toMillis } from '@bridebook/toolbox/src/time-utils/time-utils';
import { useQuery } from '@tanstack/react-query';
import { GetRsvpDataBody } from '@bridebook/web/pages/api/for/website/[websiteId]/rsvp/guest/get';

export const PUBLIC_GUEST_RSVP_ROOT_QUERY_KEY = 'public-guest-rsvp';

const CACHE_TIME = toMillis(15, 'min');

export const usePublicGuestRsvp = (
  websiteId: string,
  params: GetRsvpDataBody | undefined,
  options: {
    keepPreviousData?: boolean;
  },
) => {
  const { data, isLoading, isError, error, isFetching } = useQuery(
    [PUBLIC_GUEST_RSVP_ROOT_QUERY_KEY, 'single', websiteId, params],
    async () => {
      try {
        if (!websiteId || !params) {
          throw new Error('missing_params');
        }

        const guestRsvpResponse = await fetchGuestRsvp(websiteId, params);

        if (guestRsvpResponse.httpStatus === 200 || guestRsvpResponse.httpStatus === 401) {
          return guestRsvpResponse.data;
        } else if (guestRsvpResponse.httpStatus === 404) {
          return {
            resultCode: 'not_found' as const,
          };
        } else {
          throw new Error('api_error', {
            cause: guestRsvpResponse,
          });
        }
      } catch (error) {
        return {
          resultCode: 'error' as const,
          error,
        };
      }
    },
    {
      cacheTime: CACHE_TIME,
      staleTime: CACHE_TIME,
      keepPreviousData: options.keepPreviousData,
    },
  );

  return {
    data,
    isLoading,
    isError,
    error,
    isFetching,
  };
};
